import { render, staticRenderFns } from "./russia_business.vue?vue&type=template&id=0992fe98&scoped=true"
import script from "./russia_business.vue?vue&type=script&lang=js"
export * from "./russia_business.vue?vue&type=script&lang=js"
import style0 from "./russia_business.vue?vue&type=style&index=0&id=0992fe98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0992fe98",
  null
  
)

export default component.exports